import axios from "axios";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {BannerSlider} from "../BannerSlider/Slider";
import DealsContainer from "./DealsContainer";

const Deals = ({ restUrl }) => {
    let date = new Date();
    let tomorrow =  date.getFullYear() + "-" + ((date.getMonth() + 1 < 10 ? "0" : "") + date.getMonth() + 1)  + "-" + ((date.getDate() + 1 < 10 ? "0" : "") + date.getDate()+1);
    //let nextYear = (date.getFullYear() + 1) + "-" + (date.getMonth() + 1)  + "-" + (date.getDate()+1);
    let paidUrl = "/api/solr?filters={\"featured_end_date\": \"[" + tomorrow + " TO *]\", \"featured_type_varchar\": \"(16307 OR 16308) OR featured_type:(16307 OR 16308)\"}&sort=product_id desc&pageSize=5";
    let freeUrl = "/api/solr?filters={\"featured_end_date\": \"[" + tomorrow + " TO *]\", \"featured_type_varchar\": \"(16306) OR featured_type:(16306)\"}&sort=product_id desc&pageSize=5";
    const [dealsState, setDealsState] = useState({
        loading: true,
        error: false,
        paidItems: null,
        freeItems: null
    });
    // eslint-disable-next-line no-unused-vars
    const { loading, paidItems, freeItems, error } = dealsState;
    const Item = ({title, data}) => {
        return (
            <div>
                <h2 className="title title-style deals-title">{title}</h2>
                <div className="body-style">
                    <div className="flex-container">
                        {!data ? "Loading..." : <DealsContainer
                            data={data}
                            restUrl={restUrl}
                        />}
                    </div>
                </div>
            </div>
        );
    };

    useEffect(() => {
        Promise
            .all([axios.get(paidUrl), axios.get(freeUrl)])
            .then(([paid_resp, free_resp]) => {
                setDealsState({
                    ...dealsState,
                    error: false,
                    loading: false,
                    paidItems: [...paid_resp.data.response.result],
                    freeItems: [...free_resp.data.response.result]
                });
            })
            .catch(err => {
                setDealsState({
                    ...dealsState,
                    error: true,
                    loading: false
                });
                console.error(err);
            });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    //if (loading) return <DealsLoading loading={loading} />;
    //if (error || items === null) return <DealsError />;
    return (
        <div>
            <BannerSlider />
            {paidItems !== null && paidItems.length === 0 ? <h2 className="title title-style deals-title-center">We are currently in the process of updating the deals on LabX.com, please check back later today. In the meantime we&apos;d like to suggest you visit our new <a href="/showcase">LabX Showcase</a></h2> : <Item title="Great Deals on LabX.com!" data={paidItems} />}
            <div>&nbsp;</div>
            {freeItems !== null && freeItems.length > 0 && <Item title="More Deals on LabX.com!" data={freeItems} />}
        </div>
    );
};

Deals.defaultProps = {
    restUrl: "",
    title: "",
    data: null
};

Deals.propTypes = {
    restUrl: PropTypes.string.isRequired,
    title: PropTypes.string,
    data: PropTypes.array
};

export default Deals;
